import { randomInt } from './random-int.js';

const removeRandomItem = (list) => {
    const i = randomInt(list.length);
    return list.splice(i, 1)[0];
};

export { removeRandomItem };
//# sourceMappingURL=remove-random-item.js.map
